import { Link } from "react-router-dom";
import type { MediaItem } from "@/lib/types";
import { typeLabel } from "@/lib/catalog";

interface ResultCardProps {
  item: MediaItem;
  keyword: string;
}

function highlight(text: string, keyword: string) {
  const q = keyword.trim();
  if (!q) return text;
  const idx = text.toLowerCase().indexOf(q.toLowerCase());
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx)}
      <mark className="rounded bg-primary-200 px-0.5 text-primary-900">
        {text.slice(idx, idx + q.length)}
      </mark>
      {text.slice(idx + q.length)}
    </>
  );
}

export default function ResultCard({ item, keyword }: ResultCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300 md:p-4"
    >
      <div className="h-24 w-16 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-32 md:w-20">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title} - 金桔影院`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
            {highlight(item.title, keyword)}
          </h3>
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-800">
            {typeLabel(item.type)}
          </span>
        </div>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500 md:text-sm">
          {item.synopsis}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-x-3 gap-y-1 pt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1 font-semibold text-primary-600">
            <i className="ri-star-fill text-[11px]"></i>
            {item.rating.toFixed(1)}
          </span>
          <span>{item.year}</span>
          <span>{item.region}</span>
          <span className="hidden sm:inline">{item.genres.join(" · ")}</span>
        </div>
      </div>
    </Link>
  );
}